type GetMe = {
	extended_profile: ExtendedProfile;
};
type ExtendedProfile = {
	job_title: string;
	team_type: string;
};
export type GetUserSegmentationDataResponse = {
	title?: string;
	teamType?: string;
};

const LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY = 'loom-recorder.user-segmentation';

const handleFetchResponse = (response: Response) => {
	if (response.ok) {
		return response.json();
	}

	const error = new Error(`API responded with failure HTTP code: ${response.status}`);
	throw error;
};

export const getAtlassianAccount = async (): Promise<GetMe> =>
	fetch('/gateway/api/me').then(handleFetchResponse);

export const getUserSegmentationData = async (): Promise<GetUserSegmentationDataResponse> => {
	// Try to read from local storage
	try {
		const cachedUserSegmentation = localStorage.getItem(
			LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY,
		);
		if (cachedUserSegmentation) {
			return JSON.parse(cachedUserSegmentation) as GetUserSegmentationDataResponse;
		}
	} catch (e) {
		// Ignore localStorage errors
	}

	try {
		const { extended_profile: extendedProfile } = await getAtlassianAccount();

		const userSegmentationData = {
			title: extendedProfile.job_title,
			teamType: extendedProfile.team_type,
		};

		// Save to local storage
		try {
			localStorage.setItem(
				LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY,
				JSON.stringify(userSegmentationData),
			);
		} catch (e) {
			// Ignore localStorage errors
		}

		return userSegmentationData;
	} catch (err) {
		// TODO add error analytics
	}

	return {};
};
